import React, { useState } from "react";

const SeatAvailability = () => {
  // Dummy seat list
  const seats = [
    "1A", "1B", "1C",
    "2A", "2B", "2C",
    "3A", "3B", "3C",
  ];

  // Which seats are occupied?
  const occupiedSeats = ["1C", "2C", "3C"];

  // Passenger List
  const [passengers, setPassengers] = useState([
    { id: 1, type: "Adult 1", seat: "" },
    { id: 2, type: "Child 1", seat: "" },
    { id: 3, type: "Infant 1", seat: "" },
  ]);

  // Track active passenger
  const [activePassenger, setActivePassenger] = useState(1);

  // Handle seat selection
  const handleSeatSelect = (seat) => {
    if (occupiedSeats.includes(seat)) return; // Cannot select occupied seat

    setPassengers((prev) =>
      prev.map((p) =>
        p.id === activePassenger
          ? { ...p, seat: p.seat === seat ? "" : seat } // Toggle seat
          : p
      )
    );
  };

  return (
    <div className="container">
      <div className="row">

        {/* ---------------- LEFT PANEL ---------------- */}
        <div className="col-md-3">
          <div className="flight_orint">
            <p>Flight Orientation</p>
            <img src="/assets/images/flight-blue.png" alt="" />
          </div>
          <div className="flight_orint">
            <h5>Seat Fee</h5>
            <div className="d-flex mb-2">
              <span className="fees"></span>
              <span><i className="fa fa-inr"></i> 200</span>
            </div>
          </div>
          <div className="flight_orint">
            <h5>Seat Status</h5>
            <div className="d-flex mb-2"><span className="Available"></span>Available</div>
            <div className="d-flex mb-2"><span className="Occupied"></span>Occupied</div>
            <div className="d-flex mb-2"><span className="Selected"></span>Selected</div>
          </div>
        </div>

        {/* ---------------- MIDDLE: SEAT MAP ---------------- */}
        <div className="col-md-6">
          <div className="mainCabin_seat">

            <div className="cabin1">

              {seats.map((seat) => {
                const isOccupied = occupiedSeats.includes(seat);
                const isSelected = passengers.some((p) => p.seat === seat);

                return (
                  <div key={seat} className="cabin_child_1">
                    <div className="seat">
                      <input
                        type="checkbox"
                        id={seat}
                        disabled={isOccupied}
                        checked={isSelected}
                        onChange={() => handleSeatSelect(seat)}
                      />
                      <label htmlFor={seat} className={
                        isOccupied ? "occupied" :
                          isSelected ? "selected" : "available"
                      }>
                        
                        {seat}
                      </label>
                    </div>
                  </div>

                );
              })}

            </div>



            <div className="cabin2">

              {seats.map((seat) => {
                const isOccupied = occupiedSeats.includes(seat);
                const isSelected = passengers.some((p) => p.seat === seat);

                return (
                  <div key={seat} className="cabin_child_1">
                    <div className="seat">
                      <input
                        type="checkbox"
                        id={seat}
                        disabled={isOccupied}
                        checked={isSelected}
                        onChange={() => handleSeatSelect(seat)}
                      />
                      <label htmlFor={seat} className={
                        isOccupied ? "occupied" :
                          isSelected ? "selected" : "available"
                      }>
                        {seat}
                      </label>
                    </div>
                  </div>

                );
              })}

            </div>

            <div className="cabin3">

              {seats.map((seat) => {
                const isOccupied = occupiedSeats.includes(seat);
                const isSelected = passengers.some((p) => p.seat === seat);

                return (
                  <div key={seat} className="cabin_child_1">
                    <div className="seat">
                      <input
                        type="checkbox"
                        id={seat}
                        disabled={isOccupied}
                        checked={isSelected}
                        onChange={() => handleSeatSelect(seat)}
                      />
                      <label htmlFor={seat} className={
                        isOccupied ? "occupied" :
                          isSelected ? "selected" : "available"
                      }>
                        {seat}
                      </label>
                    </div>
                  </div>

                );
              })}

            </div>

          </div>
        </div>

        {/* ---------------- RIGHT PANEL ---------------- */}
        <div className="col-md-3">
          <div className="SeleSeat">Select Seats</div>
          <div class="row">
            <div class="col-md-3 col-lg-3">
              <div class="flight_img">
                <div>
                  <img alt="IndiGo" width="50" src="https://www.d2wtravel.com/Content/Flight_Images/6E.gif" /></div>
              </div></div>
            <div class="col-md-9 col-lg-9">
              <figure class="flight_sect"><span>6E-6022</span><span class="airlineImage">IndiGo </span>
              </figure>
            </div>
          </div>
          {/* Passenger List */}
          <div className="pax_deal">
          <div className="mainSet">
            <div className="set_left">Pax</div>
            <div className="set_middle">Seat</div>
            <div className="set_right">Fee</div>
          </div>

          {passengers.map((p) => (
            <div
              key={p.id}
              className={`mainSet_selct ${activePassenger === p.id ? "active" : ""}`}
              onClick={() => setActivePassenger(p.id)}
              style={{ cursor: "pointer" }}
            >
              <div className="set_left px">{p.type}</div>
              <div className="set_middle numbr">{p.seat || "--"}</div>
              <div className="set_right fe">{p.seat ? "200" : "0"}</div>
            </div>
          ))}

          {/* Total Fee */}
          <div className="mainSet totl">
            <div className="total_set">Total Seat Fee</div>
            <div className="total_set_fe">
              ₹{" "}
              {passengers.filter((p) => p.seat !== "").length * 200}
            </div>
          </div>
          </div>

          <button className="btn btn-primary btn-sm m-2">Proceed With Seats</button>
          <button className="btn btn-primary btn-sm m-2" data-bs-dismiss="modal">Proceed Without Seats</button>
          <div class="seatsConditions">* Conditions apply. We will try our best to accomodate your seat preferences, however due to operational considerations we can't guarantee this selection. The seat map shown may not be the exact replica of flight layout, we shall not responsible for losses arising from the same. Thank you for your understanding</div>

        </div>

      </div>
    </div>
  );
};

export default SeatAvailability;
